var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section-card" },
    [
      _c(
        "b-row",
        { staticClass: "help-text" },
        [
          _vm.immediateCharge
            ? _c("b-col", { staticClass: "text-danger" }, [
                _vm._v(
                  "\n      Your card will be charged straight away.\n    "
                ),
              ])
            : _c("b-col", [
                _vm._v(
                  "\n      Your card won't be charged until your order is ready to go out.\n    "
                ),
              ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.loadingStoredCards
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "loading-spinner",
                    { attrs: { "data-cy": "stripe-loading-spinner" } },
                    [
                      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v(
                          "\n          Please wait while we load the Users Stored Cards\n        "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.processing
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "loading-spinner",
                    { attrs: { "data-cy": "processing-spinner" } },
                    [
                      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v(
                          "\n          Please wait while we store the credit card details\n        "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "no-ssr-loader",
                [
                  _c("stripe-payments-user-stored-card-chooser", {
                    attrs: { userid: _vm.userid },
                    on: {
                      processing: _vm.setProcessing,
                      loading: _vm.__loading,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "stored-card-header",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "mt-4" }, [
                              _vm._v(
                                "\n              Select from the Stored cards currently linked to your account or enter a new card details.\n            "
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "stored-card-message",
                        fn: function () {
                          return [_vm._v("\n            ​\n          ")]
                        },
                        proxy: true,
                      },
                      {
                        key: "enter-new-card-label",
                        fn: function () {
                          return [
                            _vm._v(
                              "\n            Enter another card details\n          "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.selectedCard,
                      callback: function ($$v) {
                        _vm.selectedCard = $$v
                      },
                      expression: "selectedCard",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }